<script setup lang="ts">
import LabelView from '@components/util/LabelView.vue';
import { hotelListSearchStars } from '@itinerary/hotel/HotelModuleTypes';

const itineraryStore = useItineraryStore();
const route = useRoute();

const targetPersianName = computed(() => itineraryStore.targetPersianName);
const labels = computed(() =>
    hotelListSearchStars.map(l => ({
        link: `${route.path}/${l.key}-star`,
        title: `هتل های ${l.count} ستاره ${targetPersianName.value}`,
        backgroundColor: '#fff',
    }))
);
</script>

<template>
    <div class="categories-labels-container">
        <div class="container">
            <h2>دسته بندی هتل های {{ targetPersianName }}</h2>
            <div class="list">
                <template v-for="label in labels || []" :key="label.title">
                    <NuxtLink :to="label.link">
                        <LabelView max-width="300px" :label />
                    </NuxtLink>
                </template>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.categories-labels-container {
    display: flex;
    flex-direction: column;
    .list {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        padding: 4px 0;
        :not(:last-child) {
            margin-left: 4px;
        }
    }
}
</style>
